import React, { Component } from 'react';
import Helmet from 'react-helmet';
import * as defaultConst from '../../utils/clientConstant';
import commonUtil from '../../utils/commonUtil';

const version = require('../../../version.json');

export default class ApplyCSS extends Component {
  constructor(props) {
    super(props);
    this.pageName = props.pageName;
    this.pageTitle = props.title ? props.title : 'LP-GR';
    this.channel = '';
  }

  updateMetatags() {
    let meta = [];

    if (this.channel === defaultConst.constChannel.WAP) {
      meta.push(
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />,
      );
    } else {
      meta.push(<meta name="viewport" content="width=device-width, initial-scale=1" />);
    }

    if (this.pageName === 'grHomepage') {
      /**
       * MetaTags Home
       */
      meta = [
        ...meta,
        ...[
          <meta property="og:title" key={commonUtil.getUniqueKey()} content="La Mesa de Regalos se renueva para ti" />,
          <meta
            property="og:description"
            key={commonUtil.getUniqueKey()}
            content="Nuevos beneficios y herramientas para el evento de tus sueños"
          />,
          <meta
            property="og:image"
            key={commonUtil.getUniqueKey()}
            content="https://assets.liverpool.com.mx/assets/images/share/liverpool_share_list.png"
          />,

          <meta property="title" key={commonUtil.getUniqueKey()} content="La Mesa de Regalos se renueva para ti" />,
          <meta
            property="description"
            key={commonUtil.getUniqueKey()}
            content="La Mesa de Regalos se renueva para ti, nuevos beneficios y herramientas para el evento de tus sueños."
          />,
          <meta
            property="image"
            key={commonUtil.getUniqueKey()}
            content="https://assets.liverpool.com.mx/assets/images/share/liverpool_share_list.png"
          />,
        ],
      ];
    } else if (this.pageName === 'giftList') {
      /**
       * MetaTags Social Networks
       */
      meta = [
        ...meta,
        ...[
          <meta property="og:title" key={commonUtil.getUniqueKey()} content="Mesa de Regalos." />,
          <meta property="og:description" key={commonUtil.getUniqueKey()} content="Visita mi Lista de Regalos." />,
          <meta
            property="og:image"
            key={commonUtil.getUniqueKey()}
            content="https://assets.liverpool.com.mx/assets/images/share/liverpool_share_list.png"
          />,

          <meta property="title" key={commonUtil.getUniqueKey()} content="Mesa de Regalos." />,
          <meta
            property="description"
            key={commonUtil.getUniqueKey()}
            content="La Mesa de Regalos se renueva para ti, nuevos beneficios y herramientas para el evento de tus sueños."
          />,
          <meta
            property="image"
            key={commonUtil.getUniqueKey()}
            content="https://assets.liverpool.com.mx/assets/images/share/liverpool_share_list.png"
          />,
        ],
      ];
    } else if (this.pageName === 'headerLP') {
      /**
       * MetaTags Social Networks
       */
      meta = [
        ...meta,
        ...[
          <meta property="og:title" key={commonUtil.getUniqueKey()} content="Mesa de Regalos." />,
          <meta property="og:description" key={commonUtil.getUniqueKey()} content="Visita mi Lista de Regalos." />,
          <meta
            property="og:image"
            key={commonUtil.getUniqueKey()}
            content="https://assets.liverpool.com.mx/assets/images/share/liverpool_share_list.png"
          />,

          <meta property="title" key={commonUtil.getUniqueKey()} content="Mesa de Regalos." />,
          <meta
            property="description"
            key={commonUtil.getUniqueKey()}
            content="La Mesa de Regalos se renueva para ti, nuevos beneficios y herramientas para el evento de tus sueños."
          />,
          <meta
            property="image"
            key={commonUtil.getUniqueKey()}
            content="https://assets.liverpool.com.mx/assets/images/share/liverpool_share_list.png"
          />,
        ],
      ];
    }

    return meta;
  }
  render() {
    const channel = commonUtil.getChannel();
    const baseURL = commonUtil.getAppBaseURL();
    const brand = commonUtil.getBrand().toLocaleLowerCase();
    const site = commonUtil.getBrand().toLocaleUpperCase();
    this.channel = channel;
    let cssPageMap = {};
    if (channel === defaultConst.constChannel.WEB) {
      cssPageMap = require('./cssWebPageMap.json').cssPageMap;
    } else if (channel === defaultConst.constChannel.WAP) {
      cssPageMap = require('./cssWapPageMap.json').cssPageMap;
    } else {
      // Default Web css will be loaded.............
      cssPageMap = require('./cssWebPageMap.json').cssPageMap;
    }
    const pageCSS = cssPageMap[this.pageName];

    return (
      <div>
        <Helmet title={this.pageTitle} />
        <Helmet>
          <meta charSet="utf-8" />
          {this.updateMetatags()}
          <link rel="icon" href={baseURL + commonUtil.getFavicons(site)} type="image/x-icon" />
            <link rel="stylesheet" type="text/css" href={baseURL + '/themes/'+brand + '.css?v=' + version.version} />
          {cssPageMap.commonCSS.map((css, key) => (
            <link rel="stylesheet" key={key} type="text/css" href={baseURL + css + '?v=' + version.version} />
          ))}
          {cssPageMap.commonCSSFont.map((css, key) => (
            <link rel="stylesheet" key={key} type="text/css" href={baseURL + css + '?v=' + version.version} />
          ))}
          {cssPageMap.externalCSS &&
            cssPageMap.externalCSS.map((css, key) => (
              <link rel="stylesheet" key={key} type="text/css" href={baseURL + css + '?v=' + version.version} />
            ))}
          if (pageCSS)
          {pageCSS &&
            pageCSS.map((css, key) => (
              <link rel="stylesheet" key={key} type="text/css" href={baseURL + css + '?v=' + version.version} />
          ))}
        </Helmet>
      </div>
    );
  }
}
